import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";

import { Header } from "../../components";
import { styles } from "../../styles/global";
import { getRequestMetadata } from "../../api";
import UsersTable from "../../components/Users/UsersTable";
import { BodyContainer } from "../../components/BaseComponents";

function Users(props) {
  const organizationId = getRequestMetadata().suki_organization_id;

  return (
    <>
      <Header headerTitle="User Management" onDrawerToggle={props.onDrawerToggle} />
      <BodyContainer>
        <UsersTable {...props} organizationId={organizationId} />
      </BodyContainer>
    </>
  );
}

Users.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Users);
